// extracted by mini-css-extract-plugin
export var quantityInput = "_na-0";